import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 34208 35350"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#343230}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M7954 28538h18301V1105H7954v27433zm18853 1106H7401c-305 0-552-248-552-554V553c0-306 247-552 552-552l19406-1c304 0 551 248 551 553l1 28537c0 306-248 554-552 554z"
        className="fil0"
      />
      <path
        d="M11881 26256h10446c203-807 839-1443 1644-1645V5033c-805-203-1442-839-1644-1645H11881c-202 806-839 1442-1645 1645v19578c807 202 1442 838 1645 1645zm10931 1104H11396c-304 0-552-248-552-553 1-639-521-1160-1160-1160-304 0-552-247-552-552V4549c0-305 248-553 552-553 639 0 1160-521 1160-1160 1-306 248-552 552-552h11416c305 0 552 246 552 552 0 639 520 1160 1160 1160 305 0 552 248 552 553l1 20546c0 305-248 552-553 552-640 0-1160 521-1160 1160 0 305-248 553-552 553z"
        className="fil0"
      />
      <path
        d="M14279 18200c-141 0-284-55-391-162-215-216-216-566 0-781l5651-5650c214-216 564-216 780 0 216 215 216 564 0 780l-5650 5651c-107 107-249 162-390 162zM14279 14971c-141 0-284-54-391-163-215-216-216-565 0-781l2421-2420c216-216 566-216 782 0 215 215 215 564 0 780l-2422 2421c-107 109-249 163-390 163zM17508 18200c-142 0-283-55-391-162-216-216-216-566 0-781l2422-2423c214-216 564-216 780 0s216 566 0 781l-2421 2423c-109 107-250 162-390 162zM3388 31962h1178V14233H3388v17729zm1730 1105H2835c-305 0-552-247-552-552V13680c0-305 247-552 552-552h2283c305 0 552 248 552 552v18835c0 305-247 553-553 553l1-1z"
        className="fil0"
      />
      <path
        d="M7401 15374H5118c-305 0-552-247-552-552 0-306 247-552 551-552h2284c305 0 553 246 553 552 0 304-248 552-553 552zM7401 17657H5118c-305 0-552-247-552-552s247-553 551-553h2284c305 0 553 248 553 553s-248 552-553 552zM29642 31962h1178V14233h-1178v17729zm1731 1105h-2284c-305 0-552-247-552-552V13680c0-305 247-552 552-552h2284c304 0 551 248 551 552v18835c0 305-247 553-551 553v-1z"
        className="fil0"
      />
      <path
        d="M29089 15374h-2282c-305 0-553-247-553-552 1-306 248-552 553-552h2282c306 0 553 246 553 552 0 304-247 552-553 552zM29089 17657h-2282c-305 0-553-247-553-552 1-305 248-553 553-553h2282c306 0 553 248 553 553s-247 552-553 552zM1104 34246h31999v-1179H1104v1179zm32551 1104H552c-305 0-552-246-552-552l1-2283c0-305 246-553 551-553h33103c305 0 553 248 553 553v2283c0 306-248 552-553 552z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
